import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties"; //@ts-check

import React from 'react';
import { Typography } from '@material-ui/core';
/**
 * @typedef {object} Props  
 * @property {string} text
 * 
 * @param {Props} props
 */

var GridViewNoData = function GridViewNoData(_ref) {
  var text = _ref.text,
      rest = _objectWithoutProperties(_ref, ["text"]);

  return React.createElement("span", null, React.createElement(Typography, rest, text));
};

GridViewNoData.defaultProps = {
  text: 'No items'
};
export default GridViewNoData;